import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Calendar } from 'primereact/calendar'
import Icons from 'assets/icons'
import {useFileReader} from 'hooks/useFileReader'
import RichEditor from 'components/richEditor/RichEditor'
import moment from 'moment'

const AddMemoModalContent = ({ handleClose, handleAdd, addMemoModal }) => {
    const { projectId } = useParams()
    const [saveSla, loading] = useRequest()
    const { showToast } = useToast()
    const [deleteFile] = useRequest()
    const [uploadFile] = useRequest()
    const [filesData, setFilesData, convert] = useFileReader(addMemoModal?.edit ? addMemoModal?.data?.files : [])
    const [addForm, setAddForm] = useState(addMemoModal.edit ? addMemoModal?.data : {
        projectId: projectId,
        reviewDate: new Date(),
        reminderDate: null,
        note: null,
        files: []
    })
    const validateSelectedFile = (file) => {
        const MAX_FILE_SIZE = 20480 // 20MB
        const fileSizeKiloBytes = file.size / 1024
        let errorMsg = ''
        if(fileSizeKiloBytes > MAX_FILE_SIZE){
          errorMsg = "Dosya 20mb'dan küçük olmalıdır ";
        }
        return errorMsg
      };
    const uploadFiles = async (fileList) => {
		let errorMessage = ''
		for (let i = 0; i < fileList.length; i++) {
			const file = fileList[i];
			if (validateSelectedFile(file) != '') {
				errorMessage = validateSelectedFile(file)
				break
			}
		}
		if (errorMessage == '') {
			for await (const file of fileList) {
				const formData = new FormData();
				formData.append("File", file);
				formData.append('MemoId', addMemoModal.data.id)
				uploadFile('/Memo/AddMemoDocuments', {
					method: 'POST',
					data: formData
				}).then(res => {
					if (res.data.ok) {
						convert(fileList)
					}else {
						showToast(res.data.metadata.message,'error')
					}
				})
			}
		}else {
			showToast(errorMessage,'error')
		}
	};
    const handleChange = (e) => {
        if (e.name == 'files') {
            if (addMemoModal?.edit) {
                uploadFiles(e.files)
            }
            else {
                convert(e.files)
            }
        } else {
            setAddForm(prev => ({ ...prev, [e.name]: e.value }))
        }
    }
    const removeFile = (file) => {
        setFilesData(prev => ([...prev.filter(f => f.fileName != file.fileName)]))
    }
    const handleSubmit = () => {
        if (!addForm.note) {
            showToast('Lütfen Bir Not Girin', 'error')
        }
        else if (addMemoModal?.edit) {
            saveSla('/Memo/UpdateMemos', {
                method: 'PUT',
                data: addForm,
            }).then((res) => {
                if (res.data.ok) {
                    handleClose()
                    handleAdd()
                    setFilesData([])
                    showToast('Güncelleme Başarılı', 'success')
                }
            })
        }
        else {
            const formDatas = new FormData()
            formDatas.append("ProjectId", addForm.projectId);
            formDatas.append("ReviewDate", moment(addForm.reviewDate).toISOString());
            formDatas.append("Note", addForm.note);
            formDatas.append("ReminderDate", addForm.reminderDate);
            filesData.forEach(f => {
                formDatas.append('File', f.file)
            })
            saveSla('/Memo/AddMemos', {
                method: 'POST',
                data: formDatas
            }).then(res => {
                if (res.data.ok) {
                    showToast('Memo Oluşturuldu', 'success')
                    handleClose()
                    handleAdd()
                    setFilesData([])
                }
            })
        }
    }
    const handleDelete = async (deleteData) => {
		deleteFile('/Memo/DeleteMemoDocuments', {
			method: 'DELETE',
			data: deleteData
		}).then(res => {
			if (res.data.ok) {
				removeFile(deleteData)
			}
		})
	}
    return (
        <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
            <div className="row mt-2">
                <div className='col-md-12'>
                    <div className='form-control'>
                        <Calendar
                            dateFormat='dd/mm/yy'
                            placeholder='Review Tarihi'
                            name='reviewDate'
                            disabled
                            value={new Date(addForm.reviewDate)}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='col-md-12'>
                    <div className='form-control'>
                       <RichEditor
                        noImage
                        defaultContentState={addForm.note}
                        setState={(value) => handleChange({name:'note',value:value})}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
                        <span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Dosya yüklemek için tıklayınız</span>
                    </label>
                    <input
                        type='file'
                        // accept="image/*,video/*"
                        name='files'
                        onChange={(e) => handleChange(e.target)}
                        id='file-uploader'
                        className='filterTask-file-upload--form--row--item--file-uploader--input'
                    />
                </div>
                <div className='ml-4 d-flex w-100 mt-2 gap-3'>
                    {filesData?.length > 0 &&
                        filesData?.map((file, i) => (
                            <div className='text-sm comment-fileList w-unset' key={i}>
                                <div className='d-flex align-items-center'>{file?.fileName}</div>
                                <Icons.delete className='cursor-pointer' onClick={() => {
                                    if (addMemoModal?.edit) {
                                        handleDelete({id:file.id,memoId:file.memoId, fileName:file.fileName})
                                    } else {
                                        removeFile(file)
                                    }
                                 }} size={16} />
                            </div>
                        ))}
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <Button handleClick={handleSubmit} disabled={loading} className='btn-success w-100 justify-content-center' title={addMemoModal?.edit ? 'Güncelle' : 'Ekle'} />
                </div>
                <div className="col-md-6">
                    <Button handleClick={handleClose} className='btn-danger-outline w-100 justify-content-center' title={'Vazgeç'} />
                </div>
            </div>
        </div>
    )
}
AddMemoModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    addMemoModal: PropTypes.object
}
export default AddMemoModalContent